import React from 'react';
import { canDownloadPageItem } from './PageSections';

export const renderPageCollectionAction = ({
  collection,
  pageId,
  onShowModal,
  intl,
}) => {
  if (!pageId || !collection?.uuid || !canDownloadPageItem(collection)) return null;

  const label = intl.formatMessage({ defaultMessage: 'Download collection' });

  return (
    <li>
      <a
        href="#download"
        id={`PageCollectionDownload-${collection.uuid}`}
        aria-label={label}
        title={label}
        onClick={(event) => {
          event.preventDefault();
          event.stopPropagation();
          onShowModal('DownloadModal', {
            className: 'modal-download',
            files: [],
            collections: [collection],
            pageId,
            backdrop: true,
          });
        }}
      >
        <i className="far fa-download" aria-hidden="true" />
      </a>
    </li>
  );
};

export const renderPageFileAction = ({
  actionFile,
  actionView,
  displayFile,
  allowDownload,
  pageId,
  onShowModal,
  intl,
}) => {
  if (!allowDownload) return null;

  const targetFile = actionFile || displayFile;
  const canOpenModal = !!(pageId && targetFile?.uuid);
  const href = targetFile?.url || displayFile?.url || null;
  const label = intl.formatMessage({ defaultMessage: 'Download' });

  if (!canOpenModal && !href) return null;

  const actionId = `FileActionDownload-${targetFile?.uuid || 'puck-file'}-${actionView || 'grid'}`;
  const handleClick = (event) => {
    event.preventDefault();
    onShowModal('DownloadModal', {
      className: 'modal-download',
      files: [targetFile],
      collections: [],
      pageId,
      backdrop: true,
    });
  };

  return (
    <li>
      <a
        href={canOpenModal ? '#download' : href}
        id={actionId}
        {...(canOpenModal ? { onClick: handleClick } : {
          download: targetFile?.original_name || targetFile?.originalName || 'file',
        })}
        aria-label={label}
        title={label}
      >
        <i className="far fa-download" aria-hidden="true" />
      </a>
    </li>
  );
};
